export default __webpack_public_path__ + "static/media/cp_geo_gt.f6b8c0f1.svg";